import { getSVG } from './components/icons-loader.js';
import { handleDemoFormOrBot } from './components/get-a-demo.js';

document.addEventListener("DOMContentLoaded", async function () {
  getSVG();
  handleDemoFormOrBot();
});
